/* eslint-disable */
import React from 'react';

const IconImage60 = (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="60" height="60" fill="#2183CA"/>
        <g mask="url(#mask0_4937_1251)">
            <line y1="49" x2="62" y2="49" stroke="white" strokeWidth="2"/>
            <path
                d="M4 49L25.9231 28.4286L33.3221 35.8571M40.7212 43.2857L33.3221 35.8571M33.3221 35.8571L46.75 21L61 35.8571"
                stroke="white" strokeWidth="2"/>
            <circle cx="14" cy="18" r="6" stroke="white" strokeWidth="2"/>
        </g>
    </svg>
);

export default IconImage60;
